import { ControlType, FetchStatus } from "../../../../base/types";
import { ErrorMessage, Spinner } from "../../../../widgets";
import { DraftFPXBankButtonComponent } from "./DraftFPXBankButtonComponent";
import { FC } from "react";
import { IControlAttributes } from "../../../../base/models";
import { Registry } from "../../../../base/register";
import { FPXBankProperties, useFPXBankProperties } from "./FPXBankProperties";
import { FPXBankButton } from "./FPXBankButton";
export const FPXBankButtonComponent: FC<IControlAttributes> = ({
    className, children, props
}) => {
    const { status, properties, error } = useFPXBankProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    if (!properties) return <></>

    return (
        <FPXBankButton {...properties}
            className={className}>
            {children}
        </FPXBankButton>
    )
}

Registry.addControl({
    id: "8f2558e2-8405-43c6-8860-105ae60c99c8",
    name: "FPX-Bank Button",
    type: ControlType.FPXBankButton,
    properties: FPXBankProperties,
    component: FPXBankButtonComponent,
    draftComponent: DraftFPXBankButtonComponent
})
